var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',[_c('b-nav-item',{attrs:{"href":"#/jobs"}},[_c('strong',[_vm._v("Jobs")]),_vm._v("  "),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(_vm._s(_vm.jobs.length)+" "),_c('span',{staticClass:"sr-only"},[_vm._v("unread messages")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }